import { NgModule } from '@angular/core';

import { CommonModule,DatePipe,CurrencyPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomerTransactionHistoryComponent } from '@app/components/customer-reports/customer-transaction-history/customer-transaction-history.component';
import { TransactionHistoryEndpoint } from '@app/services/transactionHistory/transactionHistory-endpoint.service';
import { TransactionHistoryService } from '@app/services/transactionHistory/transactionHistory.service';
import {SlideshowModule} from 'ng-simple-slideshow';
import { ConfirmationPopupComponent } from '../common/confirmation-popup/confirmation-popup.component';
import { ProfileDetailsService } from '@app/services/customerProfile/profile-details.service';
import { ProfileDetailsEndPoint } from '@app/services/customerProfile/profile-details-endpoint.service';

import { NgxPaginationModule } from 'ngx-pagination';
import { NgDatepickerModule } from 'ng2-datepicker';
import { EqualValidator } from '@app/directives/equal-validator.directive';
import { ExporttopdfComponent } from '@app/components/common/export-to-pdf.component';
import { FilterPipe } from '@app/pipes/searchFilter.pipe';
import { DropDownListValidationDirective } from '@app/directives/validation/dropdownlist.validation';
import { OldPasswordValidatorDirective } from '@app/directives/oldpwd-equal-validator.directive';
import { ExporttoexcelComponent } from '@app/components/common/excel-export.component';
import { CardFilterPipe, CardFilterFundAllocationPipe } from '@app/pipes/searchCardFilter.pipe';
import { CustomerEndpoint } from '@app/services/customer-registration/customer-endpoint.service';
import { CustomerService } from '@app/services/customer-registration/customer.service';
import { CustomerStatementEndpoint } from '@app/services/customerStatement/customerStatement-endpoint.service';
import { CustomerStatementService } from '@app/services/customerStatement/customerStatement.service';
import { ChartsModule } from 'ng2-charts';
import { DynamicChartComponent } from '@app/components/common/chart.component';
import { DynamicListComponent } from '@app/components/common/list.component';

import { StyleCellDirective } from '@app/directives/style-cell.directive';
import { TabularListComponent } from '@app/components/common/tabular-list/tabular-list.component';
import { FormatCellPipe } from '@app/pipes/formatCell.pipe';
import { BillingFilterPipe } from '@app/pipes/billingRequestFilter.pipe';
import { MerchantNamePipe } from '@app/pipes/merchantNameFilter.pipe';
import { AccountInfoService } from '@app/services/account-info/account-info.service';
import { AccountInfoEndpoint } from '@app/services/account-info/account-info-endpoint.service';
import { VehicleDetailsService } from '@app/services/vehicleDetails/vehicledetails.service';
import { VehicleDetailsEndpoint } from '@app/services/vehicleDetails/vehicledetails-endpoint.service';
import { CustomerFilterPipe } from '@app/pipes/customerCardfilter.pipe';
import { CCMSCardLimitPipe } from '@app/pipes/ccmsCardLimitFilter.pipe';
import { LoyaltyService } from '@app/services/loyalty/loyalty.service';
import { LoyaltyEndpoint } from '@app/services/loyalty/loyalty-endpoints.service';
import { PaymentForCardService } from '@app/services/paymentForCard/paymentForCard.service';
import { PaymentForCardEndpoint } from '@app/services/paymentForCard/paymentForCard-endpoint.service';
import { ExporttopdfmerchanttxnComponent } from '../common/export-to-pdf-merchant-txn.component';
import { ExporttopdfAdminComponent } from '@app/components/common/export-to-pdf-adminCustomerList.component';
import { TicketManagementComponent } from '@app/components/common/help-desk/ticketManagement.component';
import { HelpDeskComponent } from '../common/help-desk/helpDesk.component';
import { TerminalDetailComponent } from '@app/components/common/help-desk/terminalDetail.component';
import { RaiseTicketComponent } from '@app/components/common/help-desk/raiseTicket.component';
import { MerchantListingService } from '@app/services/merchant/merchant-listing/merchant-listing.service';
import { MerchantListingEndpoint } from '@app/services/merchant/merchant-listing/merchant-listing-endpoint.service';
import { IssueDetailsComponent } from '../common/help-desk/issueDetails.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    SlideshowModule,NgDatepickerModule,
    NgxPaginationModule
  ],
  declarations: [
    CustomerTransactionHistoryComponent,
    ConfirmationPopupComponent,EqualValidator,
    ExporttopdfComponent,
    FilterPipe,
    ExporttoexcelComponent,
    OldPasswordValidatorDirective,
    DropDownListValidationDirective,
    CardFilterPipe,
    BillingFilterPipe,
    DynamicChartComponent,
    DynamicListComponent,
    StyleCellDirective,
    TabularListComponent,
    FormatCellPipe,
    MerchantNamePipe,
    CustomerFilterPipe,
    CCMSCardLimitPipe,
    ExporttopdfmerchanttxnComponent,
    ExporttopdfAdminComponent,
    TicketManagementComponent,
    RaiseTicketComponent,
    TerminalDetailComponent,
    HelpDeskComponent,
    IssueDetailsComponent,
    CardFilterFundAllocationPipe
  ],
  exports: [
    CommonModule,
    FormsModule,
    ChartsModule,
    ReactiveFormsModule,
    CustomerTransactionHistoryComponent,
    SlideshowModule,
    ConfirmationPopupComponent,
    NgDatepickerModule,
    NgxPaginationModule,EqualValidator,ExporttopdfComponent,ExporttoexcelComponent,
    FilterPipe,
    DropDownListValidationDirective,
    OldPasswordValidatorDirective,
    CardFilterPipe,
    BillingFilterPipe,
    DynamicChartComponent,
    DynamicListComponent,
    
    StyleCellDirective,
    TabularListComponent,
    FormatCellPipe,
    MerchantNamePipe,
    CustomerFilterPipe,
    CCMSCardLimitPipe,
    ExporttopdfmerchanttxnComponent,
    ExporttopdfAdminComponent,
    TicketManagementComponent,
    RaiseTicketComponent,
    TerminalDetailComponent,
    HelpDeskComponent,
    IssueDetailsComponent,
    CardFilterFundAllocationPipe
  ],
  providers: [
     TransactionHistoryEndpoint,
     TransactionHistoryService,
     ProfileDetailsService,
     ProfileDetailsEndPoint,
     CustomerService,
     CustomerEndpoint,
     CustomerStatementService,
    CustomerStatementEndpoint,
    DatePipe,
    CurrencyPipe,
    AccountInfoService,
    AccountInfoEndpoint,
    VehicleDetailsService,
    VehicleDetailsEndpoint,
    LoyaltyService,
    LoyaltyEndpoint,
    PaymentForCardService,
    PaymentForCardEndpoint,
    MerchantListingService,
    MerchantListingEndpoint
  ]
})
export class SharedModule {
  constructor(
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/components/core/shared.module.ts